import md5 from "md5";

/**
 * Returns a Gravatar image URL for the given email address.
 * Falls back to a 404 response for unknown emails, letting
 * Chakra's Avatar component show initials instead.
 */
export function getGravatarUrl(email, size = 80) {
  if (!email) return undefined;
  const hash = md5(email.trim().toLowerCase());
  return `https://www.gravatar.com/avatar/${hash}?s=${size}&d=404`;
}
